import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M10.5 3a7.5 7.5 0 0 1 5.963 12.05L21 19.585 19.585 21l-4.536-4.537A7.5 7.5 0 1 1 10.5 3Zm0 2a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }